import React, { useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";

const ApkManagerPage = (props) => {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [activeApk, setActiveApk] = useState(null);
  const [loadingApk, setLoadingApk] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [form, setForm] = useState({
    version_name: "",
    version_code: "",
    release_notes: "",
    apk_file: null,
  });

  const { sendRequest: getApps } = useHttp();
  const { sendRequest: getActiveApk } = useHttp();


  useEffect(() => {
    fetchApps();
  }, []);

  const fetchApps = () => {
    const orgId = localStorage.getItem("orgId");
    getApps(
      {
        url: `/api/app/?orgId=${orgId}`,
      },
      (res) => {
        console.log("APPS API RESPONSE:", res);

        if (!res) return;

        const list = Array.isArray(res)
          ? res
          : res.data || res.results || res.apps || [];

        console.log("APPS LIST:", list);

        setApps(Array.isArray(list) ? list : []);
      }
    );
  };

  const handleSelectApp = (app) => {
    console.log("SELECTED APP OBJECT:", app);
    console.log("APP ID:", app?.appId);

    setSelectedApp(app);
    setActiveApk(null);

    setForm({
      version_name: "",
      version_code: "",
      release_notes: "",
      apk_file: null,
    });

    fetchActiveApk(app);
  };

  const fetchActiveApk = (app) => {
    setLoadingApk(true);
    getActiveApk(
      {
        url: `/api/apkUpload/?appId=${app.appId}`,
      },
      (res) => {
        console.log("ACTIVE APK API RESPONSE:", res);

        if (!res) {
          setActiveApk(null);
          setLoadingApk(false);
          return;
        }

        const apk = res.data ?? res;

        const resolvedApk =
          Array.isArray(apk) ? (apk.length ? apk[0] : null) :
            (apk && Object.keys(apk).length ? apk : null);

        setActiveApk(resolvedApk);
        setLoadingApk(false);
      }
    );
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, apk_file: e.target.files[0] });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!form.apk_file || !form.version_name || !form.version_code) {
      toast.warning("APK file, version name and version code are required");
      return;
    }

    const appId = selectedApp?.appId;

    console.log("SELECTED APP:", selectedApp);
    console.log("APP ID:", appId);

    if (!appId) {
      toast.error("Selected app ID is missing");
      return;
    }

    const formData = new FormData();

    formData.append("appId", String(appId));
    formData.append("apk_file", form.apk_file);
    formData.append("version_name", form.version_name);
    formData.append("version_code", String(form.version_code));
    formData.append("release_notes", form.release_notes || "");

    console.log("FORM DATA:");
    for (const [key, value] of formData.entries()) {
      console.log(key, value);
    }

    setUploading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/apkUpload/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.detail ||
          data?.message ||
          data?.errorMessage ||
          "APK upload failed"
        );
      }

      toast.success(data?.message || "APK uploaded successfully");

      setUploading(false);

      fetchActiveApk(selectedApp);
    } catch (error) {
      console.error("APK Upload Error:", error);
      toast.error(error.message || "APK upload failed");
      setUploading(false);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* LEFT - APP LIST */}
              <div className="col-md-4">
                <div className="card card-default">
                  <div className="card-header">
                    <h3 className="card-title">Apps</h3>
                  </div>
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    {apps.length === 0 && (
                      <p className="text-muted text-center">No apps found.</p>
                    )}
                    <table className="table table-bordered text-center">
                      <tbody>
                        {apps.map((app) => (
                          <tr
                            key={app.appId}
                            style={{
                              cursor: "pointer",
                              background:
                                selectedApp?.appId === app.appId ? "#f1f8f1" : "#fff",
                            }}
                          >
                            <td onClick={() => handleSelectApp(app)}>
                              {app.appName}
                              <br />
                              <small className="text-muted">{app.appIdentifier}</small>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => props.onViewHistory(app)}
                              >
                                <i className="fas fa-history"></i> History
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* RIGHT - UPLOAD FORM */}
              <div className="col-md-8">
                <div className="card card-default">
                  {!selectedApp ? (
                    <div className="card-body text-center text-muted">
                      Select an app from the left to upload a new version
                    </div>
                  ) : (
                    <form onSubmit={submitHandler}>
                      <div className="card-header">
                        <h3 className="card-title">
                          {selectedApp.appName} — Upload New Version
                        </h3>
                      </div>
                      <div className="card-body">
                        {loadingApk ? (
                          <p className="text-muted">Loading current version...</p>
                        ) : activeApk ? (
                          <div className="alert alert-success">
                            <strong>
                              Current Active: v{activeApk.version_name} (code:{" "}
                              {activeApk.version_code})
                            </strong>
                            <br />
                            <small>
                              {activeApk.file_name} — uploaded by {activeApk.uploaded_by}
                            </small>
                            <br />
                            <small>{activeApk.uploaded_at}</small>
                          </div>
                        ) : (
                          <div className="alert alert-warning">
                            No active APK found — this will be the first upload.
                          </div>
                        )}

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Version Name *</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e.g. 2.0.1"
                                name="version_name"
                                value={form.version_name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Version Code *</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="e.g. 201"
                                name="version_code"
                                value={form.version_code}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Release Notes</label>
                              <textarea
                                className="form-control"
                                placeholder="What changed in this version?"
                                name="release_notes"
                                rows={3}
                                value={form.release_notes}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>APK File *</label>
                              <input
                                type="file"
                                className="form-control"
                                accept=".apk"
                                onChange={handleFileChange}
                              />
                              {form.apk_file && (
                                <small className="text-muted">
                                  Selected: {form.apk_file.name} (
                                  {(form.apk_file.size / 1024 / 1024).toFixed(2)} MB)
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer text-right">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={uploading}
                        >
                          {uploading ? "Uploading..." : "Upload New Version"}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ApkManagerPage;